<div class="help-button-container">
  <button
    mat-mini-fab
    class="help-button"
    (click)="toggleState()"
    [color]="getHelpButtonColor()"
    aria-label="Help button that opens legend"
  >
    <mat-icon class="help-button-icon" [@helpLegendToggler]="state()">help_outline</mat-icon>
  </button>
</div>

<div [@helpLegendContainer]="state()" class="help-legend-container">
  <h4 class="legend-container-title">{{ 'fieldPlanLegend.title' | translate }}</h4>
  <mat-list>
    <ng-container
      [ngTemplateOutlet]="legendItem"
      [ngTemplateOutletContext]="{
        color: 'already-existing',
        text: 'fieldPlanLegend.existingCropField',
      }"
    />
    <ng-container
      [ngTemplateOutlet]="legendItem"
      [ngTemplateOutletContext]="{ color: 'new', text: 'fieldPlanLegend.newCropField' }"
    />
    <ng-container
      [ngTemplateOutlet]="legendItem"
      [ngTemplateOutletContext]="{ color: 'updated', text: 'fieldPlanLegend.changedCropField' }"
    />
    <ng-container
      [ngTemplateOutlet]="legendItem"
      [ngTemplateOutletContext]="{ color: 'not-present', text: 'fieldPlanLegend.notPresent' }"
    />
  </mat-list>
</div>

<ng-template #legendItem let-text="text" let-color="color">
  <mat-list-item class="legend-item">
    <mat-icon matListItemIcon [class]="['status-icon', color]">agriculture</mat-icon>
    <h3 matListItemTitle>{{ text | translate }}</h3>
  </mat-list-item>
</ng-template>
